import Simple from './Simple';
import Gql from './Gql';
import { Provider } from './Context';
var DataTable = {
  Simple: Simple,
  Gql: Gql,
  Provider: Provider
};
export default DataTable;
